/* eslint-disable no-undef */
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { AdminCloseIcon } from "../../../utils/icons";
import { StyledModal, CustomTitle } from "../../AttendeesModal/styles";
import { Border } from "../../Journeys/styles";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import { CommonButtonBorder } from "../../common/commonStyles";
import { t } from "i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import LazyImage from "../../common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";
import { fetchApi } from "../../../utils/methods";
import { toast } from "react-toastify";
import Spinner from "../../common/Spinner";
import { PostEventMomentToSocialFeed } from "../../../redux/constants/apiConstants";

const ShareOnSocialFeed = ({ showModal, onHide, heading,type,moment,history}) => {

  const[loading, setLoading] = useState(false);


  const sharePost = async()=>{
    setLoading(true);
    const payload = {moment_id:moment.id};
    try{
      const res = await fetchApi(PostEventMomentToSocialFeed, "POST",payload);
      if(res.status === "success"){
        toast.success(res?.message);
        setLoading(false);
        onHide();
        history.push("/social")
        // getSharedMoments(companyId,1)
        
      }else{
        toast.error(res.message);
        setLoading(false);
      }
    }catch(error){
      toast.error(error);
      setLoading(false);
    }

  }


  const renderCompleteChallenge = ()=>(
    <>
      {/* Body */}
      <Modal.Body style={{gap:'20px',display:'flex',flexDirection:'column',padding:'0px 16px', alignItems:'center',justifyContent:'center'}}>
        <div className="text" style={{fontWeight:'700'}}>
          {t(`Your post has been added to the event Moments feed.`)} 
        </div>
        <LazyImage style={{width:'100px'}} src={ImageUrl + '/images/event-moments/share-event-moment-to-social-feed.png'}/>
      </Modal.Body>
 
      {/* Footer */}
      <Modal.Footer
        style={{
          borderTop: "none",
          display: "flex",
          gap: "12px",
          width: "100%",
        }}
      >
        <div style={{ display: "flex", gap: "12px", marginTop: "20px",width:'100%', justifyContent:'center' }}>
          <CommonButtonPopup
            height="48px"
            width="100%"
            onClick={() =>sharePost() }
            disabled={loading}
          >
            {loading ? <Spinner color={'white'}/> : t(`Share to Social Feed`)} 
          </CommonButtonPopup>
   
          <CommonButtonBorder
            height="48px"
            width="100%"
            onClick={onHide}
          >
            {t("Maybe Later")}
          </CommonButtonBorder>
        </div>
      </Modal.Footer>
    </>

  )

  const renderInCompleteChallenge = ()=>(
    <>
      {/* Body */}
      <Modal.Body style={{gap:'20px',display:'flex',flexDirection:'column',padding:'0px 16px'}}>
        <div className="text" style={{fontWeight:'400'}}>
          {t(`Are you sure you want to share this moment on social feed?`)}
        </div>
        <div className="text" style={{color:'#CE7841'}}>
          {t("This action will post the moment on your social feed for others to see.")}
        </div>
        
      </Modal.Body>
 
      {/* Footer */}
      <Modal.Footer
        style={{
          borderTop: "none",
          display: "flex",
          gap: "12px",
          width: "100%",
        }}
      >
        <div style={{ display: "flex", gap: "12px", marginTop: "20px",width:'100%' }}>
          <CommonButtonPopup
            height="48px"
            width="100%"
            onClick={() =>sharePost() }
            disabled={loading}
          >
            {loading ? <Spinner color={'#F37A65'}/> : t(`Post Moment`)}
          </CommonButtonPopup>
   
          <CommonButtonBorder
            height="48px"
            width="100%"
            onClick={onHide}
          >
            {t("Cancel")}
          </CommonButtonBorder>
        </div>
      </Modal.Footer>
    </>
  
  )

  return (
    <StyledModal
      $width={"400px"}
      $height={"auto !important"}
      show={showModal}
      // onHide={onHide}
    >
      {/* Header */}
      <Modal.Header style={{ background: "white", border: "none" }}>
        <CustomTitle>
          <div>
            <span>{t(heading ? heading : 'Challenge incomplete')}</span>
            <span className="closeImage">
              <div onClick={onHide}>{AdminCloseIcon()}</div>
            </span>
          </div>
        </CustomTitle>
      </Modal.Header>

      <Border
        style={{
          width: "93%",
          background: "#EFEFEF",
          margin: "4px 16px 20px 16px",
        }}
      />

      {type === 'upload' ? renderCompleteChallenge() : renderInCompleteChallenge()}   


    </StyledModal>
  );
};

ShareOnSocialFeed.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  challengeId:PropTypes.number,
  moment:PropTypes.object,
  history:PropTypes.object,
  heading:PropTypes.string,
  type:PropTypes.string,
};

export default withRouter(connect(null, null)(withTranslation()(ShareOnSocialFeed)));
